import React from "react";
import classNames from "classnames";
import ImageComponent from "./ImageComponent";

const MarketingPushComponent = ({ push, perRow }) => {
  const { image, text, link_destination, background_color, text_color } = push;

  const cta_label = text || "DISCOVER";

  const gridClasses = classNames({
    "grid-item": true,
    "marketing-push-item": true,
    "grid-item--per-row-2": perRow === 2,
    "grid-item--per-row-3": perRow === 3,
    "grid-item--per-row-4": perRow === 4,
  });

  const imageUrl =
    image && image.sizes
      ? image.sizes["shop_catalog_large"]
      : image && image.url
        ? image.url
        : "";

  const isColorBar =
    !!background_color &&
    background_color.toLowerCase() !== "#ffffff" &&
    background_color.toLowerCase() !== "#fff";

  const ctaStyle = isColorBar
    ? {
        backgroundColor: background_color,
        color: text_color || "#ffffff",
      }
    : {
        backgroundColor: "#F8F7F6",
        color: "#000000",
      };

  return (
    <li className={gridClasses}>
      <div className="grid-item-inner">
        <a
          href={link_destination}
          className="marketing-push-link flex flex-col h-full w-full group outline-none transition-opacity duration-300 hover:opacity-95"
        >
          <div className="grid-item-image-wrapper relative overflow-hidden flex-shrink-0">
            {imageUrl && (
              <ImageComponent
                src={imageUrl}
                classes={["lazy-img"]}
                alt={cta_label}
                width={450}
                height={500}
                loadedCallback={() => {}}
              />
            )}
          </div>

          <div className="grid-item-footer h-full" style={ctaStyle}>
            <div className="grid-item-footer-inner flex flex-col justify-center items-center h-full">
              <span
                className={classNames(
                  "uppercase font-bold text-[0.75rem] sm:text-[0.875rem] tracking-[0.15em] underline underline-offset-4 flex justify-center items-center text-center h-full",
                  { "text-black": !isColorBar },
                )}
              >
                {cta_label}
              </span>
            </div>
          </div>
        </a>
      </div>
    </li>
  );
};

export default MarketingPushComponent;
